import { Key } from 'react'
import { CustomTreeNode } from '@/store/slices/layoutSlice'
import { isValidSideBarItem } from './isValidSideBarItem'

export const getItemKey = (item: CustomTreeNode, index: number): Key => {
  if (isValidSideBarItem(item)) {
    return item.name
  }

  return item.badge || index
}
